import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import Modalizer from 'components/modalizer/modalizer'
import PairEditor from 'views/slides/activities/matching_pairs/creation_tool/components/pair_editor/pair_editor_component'

import styles from './pair_editor_modal.scss'

class PairEditorModal extends PureComponent {

	render() {
		return (
			<Modalizer closeAction={this.props.closeModalHandler} width='606px'>
				<PairEditor
					id={this.props.id}
					clientId={this.props.clientId}
					title={this.props.title}
					card1={this.props.card1}
					card2={this.props.card2}
					imageLoadHandler={this.props.imageLoadHandler}
					changeImageMatrixHandler={this.props.changeImageMatrixHandler}
					changeTextHandler={this.props.changeTextHandler}
					discardContentHandler={this.props.discardContentHandler}
					addAnImageHandler={this.props.addAnImageHandler}
					newTextHandler={this.props.newTextHandler}
					pairSaveHandler={this.props.pairSaveHandler}
					pairStatus={this.props.pairStatus}
					pairAddAnotherHandler={this.props.pairAddAnotherHandler}
					showAddAnotherPair={this.props.showAddAnotherPair}
					deletePairHandler={this.props.deletePairHandler}
					canSave={this.props.canSave}
				/>
			</Modalizer>
		)
	}
}

export default CSSModules(PairEditorModal, styles, { allowMultiple: true })
